import React, { useMemo } from 'react';
import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { StringUtils } from '@bingads-webui-clientcenter/common-utils';
import { GlobalTaxForm } from './global-taxform';
import { TaxTypeFormPropTypes } from '../shapes';
import { GlobalTaxIdHelpPopUpId, LegalIdentifierHintI18nKey, LegalIdentifierNumberPilot, GlobalTaxIdCountryCodeToPilots } from '../constants';
import { registerTaxform } from '../taxform-store';
import { EmptyViewTaxForm } from './viewtaxforms/empty-viewtaxform';
import { addLegalIdentifierNumberInTaxSchema, withViewTaxFormWithFilledEmptyTaxValue, withTaxFormByPilot, getPilotStatus, getTaxTypeLabel } from '../utils';
import { EmptyTaxForm } from './empty-taxform';
import { CustomValidateItems } from '../validator';
import { UATaxViewTaxForm } from './viewtaxforms/ukraine-viewtaxform';

const {
  CountryCode, TaxType, TaxUAVatNumberRegExp, TaxLabelFormat,
} = Constants;
const { regexTest } = StringUtils;
const taxIdValidator = _.partial(regexTest, TaxUAVatNumberRegExp);

const taxSchemaGetter = ({ permissions }) => {
  const IsLegalIdentifierNumberPilotOn = getPilotStatus(LegalIdentifierNumberPilot, permissions);
  const taxSchema = {
    name: 'Ukraine Taxation Validation Schema',
    type: 'object',
    properties: {
      [TaxType.VatNumber]: {
        type: 'string',
        required: false,
        helpPopupTopic: GlobalTaxIdHelpPopUpId,
      },
    },
  };
  if (IsLegalIdentifierNumberPilotOn) {
    addLegalIdentifierNumberInTaxSchema(taxSchema);
  }
  return taxSchema;
};

const UkraineTaxForm = ({
  i18n,
  data,
  mtData,
  onValidate,
  showLineByLineFormGroup,
  alwaysShowError,
  taxCertification,
  mtTaxCertification,
  urlBuilder,
  disabled,
  permissions,
}) => {
  const vatValidatorErrorMessage = useMemo(() => i18n.getString(CustomValidateItems.UkraineVATFormatValidation), [i18n]);
  const vatLabel = useMemo(() => getTaxTypeLabel(TaxType.VatNumber, i18n, { labelFormat: TaxLabelFormat.RequiredForBusiness, countryCode: CountryCode.UA }), [i18n]);

  return (
    <GlobalTaxForm
      i18n={i18n}
      onValidate={onValidate}
      taxSchemaGetter={taxSchemaGetter}
      vatLabel={vatLabel}
      showLineByLineFormGroup={showLineByLineFormGroup}
      vatValidatorErrorMessage={vatValidatorErrorMessage}
      alwaysShowError={alwaysShowError}
      data={data}
      mtData={mtData}
      taxCertification={taxCertification}
      mtTaxCertification={mtTaxCertification}
      urlBuilder={urlBuilder}
      disabled={disabled}
      taxIdValidator={taxIdValidator}
      showTaxCert={false}
      permissions={permissions}
      showLegalIdentifierNumberField
      legalIdentifierHint={i18n.getString(LegalIdentifierHintI18nKey[CountryCode.UA])}
    />
  );
};

UkraineTaxForm.propTypes = TaxTypeFormPropTypes;

const pilotFlag = GlobalTaxIdCountryCodeToPilots.UA;
const TaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: UkraineTaxForm, DefaultForm: EmptyTaxForm });
const ViewTaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: UATaxViewTaxForm, DefaultForm: EmptyViewTaxForm });

registerTaxform('/UA/', TaxForm, withViewTaxFormWithFilledEmptyTaxValue({ ViewTaxForm, getTaxSchema: taxSchemaGetter }));
